export const loadScript = ({
  src,
  id,
}: {
  src: string;
  id?: string;
}): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    let s = id
      ? (document.getElementById(id) as HTMLScriptElement | null)
      : null;

    if (s === null) {
      s = document.createElement("script");
    }

    if (id) {
      s.id = id;
    }
    s.type = "text/javascript";
    s.async = true;
    s.src = src;
    s.onload = () => resolve(true);
    s.onerror = () => reject(false);

    if (!s.parentNode) {
      const node = document.getElementsByTagName("script")[0];
      if (node.parentNode) {
        node.parentNode.insertBefore(s, node);
      } else {
        // Fallback if there isn't another script on the page.
        document.head.appendChild(s);
      }
    }
  });
};
